import makeStyles from '@material-ui/core/styles/makeStyles';

export const useTaskViewActivitiesStyles = makeStyles(() => ({
  activitiesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}));
